import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    uptimeButtonContainer: {
        paddingTop: theme.spacing(4),
        position: "relative",
    },
    mainTextTitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: "26px",
    },
    mainTitleIconIconContainer: {
        position: "absolute",
        right: "5px",
    },
    mainTextTitleIconBox: {
        width: "60px",
        height: "60px",
        backgroundColor: theme.palette.error.light,
        borderRadius: "50%",
        position: "relative",
    },
    mainTextTitleIcon: {
        position: "absolute",
        color: theme.palette.error.main,
        right: "7px",
        top: "7px",
        width: "45px !important",
        height: "45px !important",
    },
    overlayTextContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 18,
    },
    overlayTextDangerousOutlinedIconLeft: {
        color: theme.palette.primary.main,
        width: "40px !important",
        height: "40px !important",
    },
    overlayTextDangerousOutlinedIconRight: {
        color: theme.palette.primary.main,
        width: "40px !important",
        height: "40px !important",
    },
    overlayTextTitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: "26px",
    },
    uptimeButton: {
        background: `${theme.palette.error.main} !important`,
        color: `${theme.palette.primary.main} !important`,
        boxShadow: "inset 2px 2px 4px rgba(0, 0, 0, 0.3)",
        borderRadius: "50px",
        border: "none !important",
        width: "470px",
        maxHeight: "48px",
        margin: "unset !important",
    },
    uptimeButtonPLC: {
        background: `${theme.palette.success.main} !important`,
        color: `${theme.palette.primary.main} !important`,
        boxShadow: "inset 2px 2px 4px rgba(0, 0, 0, 0.3)",
        borderRadius: "50px",
        border: "none !important",
        width: "470px",
        maxHeight: "48px",
        margin: "unset !important",
        padding: theme.spacing(3),
    },
    uptimeButtonCaret: {
        background: `${theme.palette.error.main} !important`,
        boxShadow: "inset 2px 2px 4px rgba(0, 0, 0, 0.3)",
        borderTopLeftRadius: "45%",
        borderBottomLeftRadius: "45%",
    },
    visibilityHidden: {
        visibility: "hidden",
    },
    uptimeButtonOverlay: {
        background: `${theme.palette.success.main} !important`,
        width: "100% !important",
        "&.slide-overlay .slide-overlay-wrapper .slide-overlay-txt": {
            width: "100% !important",
            maxWidth: "100% !important",
        },
    },
    uptimeButtonOverlayColor: {
        background: `${theme.palette.success.main} !important`,
    },
    disabledButton: {
        opacity: 0.5,
        cursor: "not-allowed",
        pointerEvents: "none",
    },

    disabledCaret: {
        opacity: 1,
    },

    disabledOverlay: {
        backgroundColor: `${theme.palette.border.main} !important`,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
    },
}));
